import { render, staticRenderFns } from "./work-with-us.vue?vue&type=template&id=fba87d8a&"
import script from "./work-with-us.vue?vue&type=script&lang=js&"
export * from "./work-with-us.vue?vue&type=script&lang=js&"
import style0 from "./work-with-us.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports